function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from 'react';
import Svg, { Circle, Defs, Ellipse, G, Line, Mask, Path, Use } from 'react-native-svg';
const PayStub = props => /*#__PURE__*/React.createElement(Svg, _extends({
  id: "Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 35 28"
}, props), /*#__PURE__*/React.createElement(G, {
  id: "Approved"
}, /*#__PURE__*/React.createElement(G, {
  id: "Loan-in-Progress-Tablet-Web-_x3E_-Initial-State",
  transform: "translate(-53 -1241)"
}, /*#__PURE__*/React.createElement(G, {
  id: "Group-15",
  transform: "translate(16 1200)"
}, /*#__PURE__*/React.createElement(G, {
  id: "Pay-Stub",
  transform: "translate(20 20)"
}, /*#__PURE__*/React.createElement(G, {
  id: "Group-12",
  transform: "translate(17.12 21.41)"
}, /*#__PURE__*/React.createElement(Path, {
  id: "Fill-1",
  d: "M13.2 9.5v.6c-1 .3-1.4 1.2-1.4 1.9 0 .2 0 .8.4 1.4.1.2.3.3.4.4h-.3c-.4.1-.7.4-.6.9.1.5.5 1.5 1.5 1.8V17.4H7.8c-.1-.5-.3-.9-.7-1.3-.4-.4-.8-.6-1.3-.7v-4.2c.5-.1.9-.3 1.3-.7.1-.1.1-.1.1-.2.3-.3.5-.7.5-1.1h5.4c.1.2.1.2.1.3m.7 4.6c.4 0 .6.1.7.2.1.1 0 .1 0 .2 0 .3-.2.6-.7.6-.6 0-.8-.5-.8-.6 0-.2-.1-.3-.3-.5.4.1.7.1 1.1.1m8.8-1c.4 0 .8-.3.8-.8v-1.5c0-.6-.5-1.1-1.1-1.1-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7 0-.6-.5-1.1-1.1-1.1h-13c-.6 0-1.1.5-1.1 1.1 0 .2-.1.4-.3.7 0 .3-.2.4-.5.4-.4 0-.8.2-.9.5-.1.2-.1.3-.1.5v4.9c0 .6.5 1.1 1.1 1.1.3 0 .5.1.7.3.2.2.3.4.3.7 0 .6.5 1.1 1.1 1.1h10.2c.4 0 .8-.3.8-.8 0-.4-.3-.8-.8-.8h-3V16.4c1-.3 1.4-1.2 1.5-1.7 0-.1.1-.8-.4-1.4-.4-.5-1-.7-1.9-.7-.3 0-.6-.1-.7-.2-.1-.1-.1-.2-.1-.2v-.1c0-.4.3-.6.7-.6.5 0 .7.2.7.6 0 .4.3.7.8.7.4 0 .7-.3.7-.8 0-.1 0-.9-.6-1.5-.2-.2-.5-.4-.8-.5v-.7H20c.1.5.3.9.7 1.3.4.4.8.6 1.3.7v1.1c0 .4.3.7.7.7"
}), /*#__PURE__*/React.createElement(G, {
  id: "Group-5"
}, /*#__PURE__*/React.createElement(Defs, null), /*#__PURE__*/React.createElement(Mask, {
  x: 0,
  y: 0,
  width: 27.8,
  height: 26.7,
  id: "mask-2_00000112593963221276449720000006877789623548843918_"
}, /*#__PURE__*/React.createElement(G, null, /*#__PURE__*/React.createElement(Path, {
  id: "path-1_00000057858469668767382660000005186792411455359674_",
  d: "M0 0h27.8v26.7H0z"
}))), /*#__PURE__*/React.createElement(Path, {
  id: "Fill-3",
  d: "M5.9 25.2 4.3 22h8.2l-6.6 3.2zm16-23.7 1.6 3.2h-8.2l6.6-3.2zm-3.3 18.9H1.5V6.2h24.8v5.5c0 .4.3.8.8.8.4 0 .8-.3.8-.8V6.2c0-.8-.7-1.5-1.5-1.5h-1.2L23.3.8c-.2-.4-.5-.6-.9-.8-.4 0-.8 0-1.2.2l-9.3 4.6H1.5C.7 4.7 0 5.4 0 6.2v14.2c0 .8.7 1.5 1.5 1.5h1.1l2 3.9c.3.5.8.8 1.4.8.2 0 .5-.1.7-.2l9.3-4.6h2.7c.4 0 .8-.3.8-.8-.1-.2-.5-.6-.9-.6z"
})), /*#__PURE__*/React.createElement(Path, {
  id: "Fill-6",
  d: "M32.9 24.6c0 .1 0 .2-.1.3-.1.1-.2.1-.3.1H21.6c-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.3v-8.1c0-.1 0-.2.1-.3.1-.1.2-.1.3-.1h.6c.4 0 .8-.3.8-.7v-.6h1.2v.6c0 .4.3.7.8.7h4.4c.4 0 .8-.3.8-.7v-.6h1.2v.6c0 .4.3.7.8.7h.6c.1 0 .2 0 .3.1.1.1.1.2.1.3v8.1zm1-9.5c-.3-.3-.7-.5-1.2-.6v-.2c0-.4-.2-.8-.6-1-.4-.2-2.6-.2-3 0-.4.2-.6.6-.6 1v.2h-2.9v-.2c0-.4-.2-.8-.6-1-.4-.2-2.6-.2-3 0-.4.2-.6.6-.6 1v.2c-.4 0-.9.2-1.2.5-.4.4-.6.8-.6 1.3v8.1c0 .5.2 1 .6 1.3.4.4.8.6 1.3.6h10.9c.5 0 1-.2 1.3-.6.4-.4.6-.8.6-1.3v-8.1c.1-.4-.1-.8-.4-1.2z"
}), /*#__PURE__*/React.createElement(Path, {
  id: "Fill-8",
  d: "M30.8 18.4h-7.6c-.4 0-.8.3-.8.8 0 .4.3.8.8.8h7.6c.4 0 .8-.3.8-.8-.1-.4-.4-.8-.8-.8"
}), /*#__PURE__*/React.createElement(Path, {
  id: "Fill-10",
  d: "M29.6 21.6h-6.4c-.4 0-.8.3-.8.8 0 .4.3.8.8.8h6.4c.4 0 .8-.3.8-.8-.1-.4-.4-.8-.8-.8"
})))))));
const OtherDocuments = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: 28,
  height: 34
}, props), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Path, {
  id: "a",
  d: "M0 0h26.535v33.127H0z"
})), /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(G, {
  transform: "translate(.972 .486)"
}, /*#__PURE__*/React.createElement(Mask, {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement(Use, {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement(Path, {
  d: "M23.258 27.545h-.79V14.99l-.019-3.832c0-.378-.166-.725-.458-.96l-1.465-1.427 4.502.004.008 17.04c0 .954-.797 1.729-1.778 1.729Zm-4.183 4.124H3.39c-1.044 0-1.892-.825-1.892-1.84V7.423c0-1.016.848-1.841 1.892-1.841h8.875l-.004 2.854v3.172c-.016.322.097.623.318.847.453.456 1.186.447 1.53.44l6.85.005.008 16.929c0 1.015-.85 1.84-1.893 1.84ZM5.567 3.185c0-.953.797-1.728 1.777-1.728h8.992l-.003 3.235-.13-.125a1.284 1.284 0 0 0-.773-.429l-9.863-.01v-.943Zm15.385 8.258-5.884-.005h-.969a2.736 2.736 0 0 1-.338-.008l.004-5.85 1.359-.003 5.826 5.67.002.196Zm-1.758-9.99 5.825 5.668.002.198-5.994-.005-1.196-1.165.004-4.694 1.359-.003Zm7.324 5.581c0-.378-.166-.725-.458-.96L20.27.438a1.284 1.284 0 0 0-.755-.423L7.345 0C5.537 0 4.067 1.429 4.067 3.185v.94H3.39C1.521 4.125 0 5.605 0 7.423v22.406c0 1.818 1.52 3.298 3.391 3.298h15.684c1.87 0 3.392-1.48 3.392-3.298v-.827h.791c1.808 0 3.277-1.43 3.277-3.185v-14.95l-.017-3.833Z",
  fill: "#000",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement(Path, {
  d: "M5.705 17.265h10.267a.74.74 0 0 0 .75-.728.74.74 0 0 0-.75-.729H5.705a.74.74 0 0 0-.75.729.74.74 0 0 0 .75.728M5.705 22.952h11.568a.74.74 0 0 0 .75-.729.74.74 0 0 0-.75-.728H5.705a.74.74 0 0 0-.75.728.74.74 0 0 0 .75.729M18.034 27.187H5.704a.74.74 0 0 0-.749.728.74.74 0 0 0 .75.729h12.33a.74.74 0 0 0 .749-.729.74.74 0 0 0-.75-.728",
  fill: "#000"
})));
const UploadHistory = props => /*#__PURE__*/React.createElement(Svg, _extends({}, props, {
  width: 28,
  height: 36
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#000",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(G, {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement(Path, {
  strokeLinejoin: "bevel",
  d: "m12.248 19.34 2.82-2.593V24"
}), /*#__PURE__*/React.createElement(Path, {
  d: "m17.776 19.281-2.708-2.534"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M12.248 21.422s-3.704.532-4.206-2.533c0 0-.45-1.89 1.601-3.264 0 0-.28-1.714.923-2.57 0 0 1.122-.857 2.583 0 0 0 1.151-2.113 3.454-2.054 0 0 3.476 0 3.476 4.432 0 0 2.243.982 1.882 3.722 0 0-.561 2.666-4.178 2.32",
  strokeLinejoin: "bevel"
})), /*#__PURE__*/React.createElement(Path, {
  d: "M27 29.07V4.8c0-.901-.73-1.633-1.63-1.633H4.856c-.9 0-1.63.732-1.63 1.634v28.565c0 .902.73 1.634 1.63 1.634h16.186L27 29.062v.008Z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M23.623 3.433v-.814c0-.894-.693-1.619-1.556-1.619H2.556C1.693.993 1 1.717 1 2.612v28.299c0 .895.693 1.62 1.556 1.62h.973M19.914 34.8l.295-5.546a1.966 1.966 0 0 1 2.293-1.796l3.974.761"
})));
const PendingReview = props => /*#__PURE__*/React.createElement(Svg, _extends({}, props, {
  width: 30,
  height: 35
}), /*#__PURE__*/React.createElement(G, {
  transform: "translate(1 1)",
  stroke: "#000",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M25 26.846v4.46c0 .935-.768 1.694-1.714 1.694H1.714A1.704 1.704 0 0 1 0 31.306V1.694C0 .759.768 0 1.714 0h21.572C24.232 0 25 .759 25 1.694v7.234"
}), /*#__PURE__*/React.createElement(Ellipse, {
  cx: 18.5,
  cy: 17,
  rx: 7.5,
  ry: 8
}), /*#__PURE__*/React.createElement(Path, {
  d: "m23 23 5 6M4 13.5h8M12 14.5h8M4 17.5h7M11 18.5h9M4 21.5h8M13 22.5h7"
})));
const Approved = props => /*#__PURE__*/React.createElement(Svg, _extends({}, props, {
  width: 25,
  height: 33
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#000",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M24 9.39V2.59C24 1.713 23.294 1 22.423 1H2.577C1.707 1 1 1.713 1 2.591V30.41C1 31.287 1.706 32 2.577 32h19.846c.87 0 1.577-.713 1.577-1.591V9.389ZM6.329 8.223h13.269M6.329 11.823h12.014"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M8.976 24.108 7.92 27.435l1.62-1.066 1.27 2.499 1.17-3.694M15.767 24.108l1.056 3.327-1.62-1.066-1.27 2.499-1.169-3.694"
}), /*#__PURE__*/React.createElement(G, {
  transform: "translate(7 14)"
}, /*#__PURE__*/React.createElement(Path, {
  d: "m6.01.275.415-.172c.645-.267 1.387 0 1.713.632l.21.405c.164.315.45.555.783.665l.428.138c.666.212 1.06.905.91 1.592l-.094.446c-.075.35-.014.714.176 1.016l.238.384c.374.597.238 1.38-.312 1.812l-.354.281c-.279.22-.462.542-.51.892l-.061.453c-.095.7-.7 1.208-1.394 1.18l-.448-.02c-.354-.014-.7.11-.966.357l-.333.309a1.346 1.346 0 0 1-1.822 0l-.333-.309a1.353 1.353 0 0 0-.966-.357l-.448.02a1.363 1.363 0 0 1-1.394-1.18l-.061-.453a1.344 1.344 0 0 0-.51-.892l-.354-.281A1.376 1.376 0 0 1 .211 5.38l.238-.384C.639 4.695.7 4.33.625 3.98L.53 3.535c-.15-.687.245-1.38.911-1.592l.428-.138c.34-.11.62-.35.782-.665l.211-.405A1.357 1.357 0 0 1 4.575.103l.415.172c.326.137.694.137 1.027 0H6.01Z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement(Ellipse, {
  cx: 5.493,
  cy: 5.498,
  rx: 2.482,
  ry: 2.478
}))));
const W2 = props => /*#__PURE__*/React.createElement(Svg, _extends({
  id: "Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 34 36"
}, props), /*#__PURE__*/React.createElement(G, {
  id: "Approved"
}, /*#__PURE__*/React.createElement(G, {
  id: "Loan-in-Progress-Tablet-Web-_x3E_-Initial-State",
  transform: "translate(-54 -1119)"
}, /*#__PURE__*/React.createElement(G, {
  id: "Group-14",
  transform: "translate(16 1082)"
}, /*#__PURE__*/React.createElement(G, {
  id: "W-2",
  transform: "translate(20 20)"
}, /*#__PURE__*/React.createElement(G, {
  id: "Group-15",
  transform: "translate(18 17.53)"
}, /*#__PURE__*/React.createElement(Path, {
  id: "Fill-1",
  d: "M13 30.5H3.8c-1.2 0-2.3-1-2.3-2.2V3.7c0-1.2 1-2.2 2.3-2.2h17.3c1.2 0 2.3 1 2.3 2.2V13c0 .4.3.7.8.7.4 0 .8-.3.8-.7V3.7c0-2-1.7-3.7-3.8-3.7H3.8C1.7 0 0 1.6 0 3.7v24.7c0 2 1.7 3.7 3.8 3.7H13c.4 0 .8-.3.8-.7s-.4-.9-.8-.9"
}), /*#__PURE__*/React.createElement(G, {
  id: "Group-5",
  transform: "translate(14.868 15.264)"
}, /*#__PURE__*/React.createElement(Defs, null), /*#__PURE__*/React.createElement(Mask, {
  x: 0,
  y: 0,
  width: 18.5,
  height: 19.3,
  id: "mask-2_00000066478060621403366680000001676549461896533133_"
}, /*#__PURE__*/React.createElement(G, null, /*#__PURE__*/React.createElement(Path, {
  id: "path-1_00000127022329347430480190000004417626405783201925_",
  d: "M0 0h18.5v19.3H0z"
}))), /*#__PURE__*/React.createElement(Path, {
  id: "Fill-3",
  d: "M1.5 17.8c0-.8.2-1.7.6-2.4.4-.9 1-1.7 1.7-2.5 1.1-1.1 2.5-1.8 4-2.1s3.1-.1 4.5.4c1.4.6 2.6 1.5 3.5 2.8.8 1.1 1.2 2.4 1.3 3.7H1.5zM6.7 7.4c-.7-.7-1-1.5-1.1-2.5 0-.9.4-1.8 1-2.5.7-.7 1.6-1 2.5-1 .9 0 1.9.4 2.5 1 .7.6 1 1.5 1 2.5 0 .9-.4 1.8-1 2.5-.7.6-1.6 1-2.5 1-.8 0-1.7-.3-2.4-1zM17 13.3c-1-1.5-2.5-2.6-4.2-3.3-.5-.2-1-.4-1.5-.5.6-.2 1.1-.6 1.6-1 1-.9 1.5-2.2 1.5-3.5 0-1.3-.5-2.6-1.5-3.5-1-1-2.3-1.5-3.6-1.5-1.4 0-2.7.5-3.6 1.5-1 .9-1.5 2.1-1.5 3.5 0 1.3.5 2.6 1.5 3.5.5.4 1 .8 1.6 1-1.8.4-3.3 1.2-4.6 2.4-.9.8-1.5 1.8-2 2.9-.5 1.1-.7 2.3-.7 3.5 0 .3.1.5.3.7.2.2.5.3.7.3h16.5c.6 0 1-.5 1-1 0-1.8-.5-3.5-1.5-5z"
})), /*#__PURE__*/React.createElement(Path, {
  id: "Fill-6",
  d: "M17.1 20.6c0-.4-.3-.7-.8-.7H5.2c-.4 0-.8.3-.8.7s.3.7.8.7h11.1c.4 0 .8-.3.8-.7"
}), /*#__PURE__*/React.createElement(Path, {
  id: "Fill-8",
  d: "M5.2 25.1c-.4 0-.8.3-.8.7 0 .4.3.7.8.7h7c.4 0 .8-.3.8-.7 0-.4-.3-.7-.8-.7h-7z"
}), /*#__PURE__*/React.createElement(Path, {
  id: "Fill-10",
  d: "M10.5 10.2v.1c-.1.5-.3 1-.4 1.4-.1-.5-.2-1-.3-1.6L9 7.2H8l-.8 3c-.1.5-.3 1.1-.4 1.6-.1-.5-.2-1-.4-1.6l-.7-3v-.1h-1l1.6 6v.1h1l.9-3.1c.2-.5.3-1 .4-1.4.1.4.2.9.3 1.4l.8 3.1h1l1.7-6v-.1h-1l-.9 3.1z"
}), /*#__PURE__*/React.createElement(Defs, null), /*#__PURE__*/React.createElement(Mask, {
  x: 12.3,
  y: 10.4,
  width: 2.4,
  height: 0.8,
  id: "mask-4_00000113352118754619922690000004728272122741206435_"
}, /*#__PURE__*/React.createElement(G, null, /*#__PURE__*/React.createElement(Path, {
  id: "path-3_00000065075809734953942940000010362158885211453607_",
  d: "M0 34.6h33.4V0H0z"
}))), /*#__PURE__*/React.createElement(Path, {
  id: "Fill-12",
  d: "M12.3 11.2h2.5v-.8h-2.5z"
}), /*#__PURE__*/React.createElement(Defs, null), /*#__PURE__*/React.createElement(Mask, {
  x: 15.2,
  y: 7.3,
  width: 3.9,
  height: 6,
  id: "mask-4_00000137090575905198831380000000757678462543695020_"
}, /*#__PURE__*/React.createElement(G, null, /*#__PURE__*/React.createElement(Path, {
  id: "path-3_00000041974702665931536670000004213942167254794930_",
  d: "M0 34.6h33.4V0H0z"
}))), /*#__PURE__*/React.createElement(Path, {
  id: "Fill-14",
  d: "M19.2 12.4h-2.5l.3-.3c1.2-1.1 2-2 2-3.1 0-.9-.6-1.8-1.9-1.8-.6 0-1.2.2-1.7.6h-.1l.3.7.1-.1c.3 0 .7-.3 1.3-.3.9 0 1.1.6 1.1 1 0 .8-.6 1.5-2.1 2.9l-.7.6v.6h3.9v-.8z"
})))))));
const HomeOwnersInsurance = props => /*#__PURE__*/React.createElement(Svg, _extends({}, props, {
  width: 36,
  height: 33
}), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Path, {
  id: "a",
  d: "M0 0h17.765v17.04H0z"
})), /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M16.915 27.05H4.336V14.604a.74.74 0 0 0-.75-.73l-1.304-.003 4.028-3.199a.727.727 0 0 0 .276-.567v-8.14h1.842v5.316c0 .28.164.534.423.657.255.121.565.09.791-.084l5.442-4.176a.68.68 0 0 1 .352-.117c.017-.002.037-.003.056-.007h.11c.15.006.293.055.387.125l3.98 3.055 4.68 3.85 4.144 3.29h-1.308a.74.74 0 0 0-.75.73c0 .403.336.73.75.73h2.35c.843 0 1.106-.47 1.181-.672.096-.263.152-.786-.555-1.35L25.606 9.46l-4.69-3.857-4.004-3.075a2.282 2.282 0 0 0-1.274-.433h-.209c-.038 0-.099.007-.154.015-.429.041-.817.187-1.122.424L9.928 5.776V1.235a.74.74 0 0 0-.75-.73H5.836a.74.74 0 0 0-.75.73v8.524L.61 13.313c-.707.563-.65 1.087-.554 1.35.074.202.338.672 1.18.672h1.6V27.78c0 .403.336.73.75.73h13.33a.74.74 0 0 0 .75-.73.74.74 0 0 0-.75-.73",
  fill: "#000"
}), /*#__PURE__*/React.createElement(G, {
  transform: "translate(17.737 15.908)"
}, /*#__PURE__*/React.createElement(Mask, {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement(Use, {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement(Path, {
  d: "M8.872 15.516c-4.436-1.85-6.829-4.07-7.329-10.394 1.46-.26 4.842-1.078 7.33-3.36 2.49 2.282 5.882 3.1 7.347 3.36-.518 6.326-2.914 8.545-7.348 10.394m8.224-11.741c-.049-.005-4.88-.546-7.668-3.545-.284-.307-.827-.306-1.113 0C5.54 3.22.717 3.77.668 3.775a.737.737 0 0 0-.667.766C.432 12.21 3.474 14.91 8.584 16.983a.754.754 0 0 0 .576 0c5.107-2.073 8.151-4.772 8.604-12.44a.738.738 0 0 0-.668-.768",
  fill: "#000",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement(Path, {
  d: "m27.342 23.205.208.258 1.663.452-.9 1.136-.179.272.076 1.569-1.284-.477-.34-.104-1.589.591.035-1.464-.009-.335-.98-1.19 1.367-.37.327-.114.854-1.278.751 1.054Zm-1.262-2.968-1.312 1.964-2.075.56a.83.83 0 0 0-.583.542l-.11.463 1.528 1.856-.053 2.19a.816.816 0 0 0 .358.695l.417.237 2.367-.88 1.986.738a.865.865 0 0 0 .803-.101l.37-.314-.12-2.442 1.34-1.686a.808.808 0 0 0 .13-.765l-.194-.426-2.488-.678-1.177-1.654c-.162-.223-.405-.389-.708-.35l-.479.051Z",
  fill: "#000"
})));
const TaxReturns = props => /*#__PURE__*/React.createElement(Svg, _extends({}, props, {
  width: 34,
  height: 37
}), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Path, {
  id: "a",
  d: "M0 0h25.02v33.158H0z"
})), /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M29.966 32.21a7.983 7.983 0 0 1-5.695 2.369 7.989 7.989 0 0 1-5.698-2.37 8.044 8.044 0 0 1-2.36-5.716 8.065 8.065 0 0 1 2.363-5.717 7.999 7.999 0 0 1 5.694-2.372c2.153 0 4.176.842 5.696 2.369a8.047 8.047 0 0 1 2.36 5.719 8.045 8.045 0 0 1-2.36 5.718m1.06-12.502a9.475 9.475 0 0 0-6.756-2.81h-.001c-2.55.003-4.95 1.002-6.753 2.814a9.561 9.561 0 0 0-2.803 6.78c0 2.563.994 4.972 2.8 6.783a9.474 9.474 0 0 0 6.758 2.81 9.475 9.475 0 0 0 6.756-2.81 9.546 9.546 0 0 0 2.799-6.783 9.548 9.548 0 0 0-2.8-6.784",
  fill: "#000"
}), /*#__PURE__*/React.createElement(G, {
  transform: "translate(0 .447)"
}, /*#__PURE__*/React.createElement(Mask, {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement(Use, {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement(Path, {
  d: "M13.466 31.652H3.58a2.087 2.087 0 0 1-2.08-2.088V3.767a2.26 2.26 0 0 1 2.253-2.261H21.44c1.146 0 2.08.936 2.08 2.088v9.97c0 .416.336.753.75.753s.75-.337.75-.753v-9.97A3.592 3.592 0 0 0 21.44 0H3.753C1.683 0 0 1.69 0 3.767v25.797a3.592 3.592 0 0 0 3.58 3.594h9.886c.414 0 .75-.337.75-.753a.752.752 0 0 0-.75-.753",
  fill: "#000",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement(Path, {
  d: "M26.683 29.639c-.654 0-1.042-.766-1.03-1.776 0-.997.364-1.787 1.03-1.787.74 0 1.018.802 1.018 1.763 0 1.046-.316 1.8-1.018 1.8m.036-4.207c-1.04 0-1.9.887-1.9 2.48.011 1.58.86 2.371 1.84 2.371 1.005 0 1.877-.827 1.877-2.492 0-1.508-.714-2.36-1.817-2.36M26.078 22.16l-4.627 8.172h.678l4.627-8.171zM20.53 24.593c0-.997.351-1.788 1.017-1.788.74 0 1.018.803 1.018 1.764 0 1.045-.315 1.798-1.018 1.798-.666 0-1.04-.765-1.017-1.774m2.883-.074c0-1.508-.727-2.358-1.83-2.358-1.04 0-1.9.888-1.9 2.468.011 1.593.86 2.383 1.84 2.383 1.017 0 1.89-.826 1.89-2.493M13.865 21.068H5.251a.752.752 0 0 0-.75.753c0 .415.336.753.75.753h8.614c.414 0 .75-.338.75-.753a.752.752 0 0 0-.75-.753M8.347 14.997V8.273h2.3v-.83H5.076v.83h2.289v6.724zM13.582 13.17c0 .102-.022.213-.056.314-.156.46-.602.908-1.306.908-.502 0-.926-.303-.926-.941 0-1.054 1.216-1.244 2.288-1.222v.941Zm.949-1.501c0-1.088-.401-2.22-2.054-2.22-.681 0-1.328.19-1.775.482l.224.65a2.687 2.687 0 0 1 1.406-.403c1.105 0 1.228.807 1.228 1.256v.111c-2.087-.01-3.249.706-3.249 2.018 0 .784.558 1.557 1.652 1.557.771 0 1.351-.38 1.653-.806h.033l.078.684h.893a7.775 7.775 0 0 1-.089-1.3v-2.03ZM16.473 14.997l.781-1.222c.201-.325.391-.616.57-.941h.022c.19.325.368.628.58.941l.793 1.222h1.116l-1.897-2.802 1.842-2.622h-1.06l-.76 1.155c-.178.29-.357.57-.536.896h-.033a17.997 17.997 0 0 0-.548-.885l-.77-1.166H15.48l1.831 2.656-1.92 2.768h1.083ZM10.661 27.976c.414 0 .75-.338.75-.753a.752.752 0 0 0-.75-.753h-5.41a.752.752 0 0 0-.75.753c0 .415.336.753.75.753h5.41Z",
  fill: "#000"
})));
const Disclosures = props => /*#__PURE__*/React.createElement(Svg, _extends({}, props, {
  width: 36,
  height: 36
}), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Path, {
  id: "a",
  d: "M0 0h26.861v35.5H0z"
})), /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(G, null, /*#__PURE__*/React.createElement(Mask, {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement(Use, {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement(Path, {
  d: "M1.5 31.746V3.754A2.257 2.257 0 0 1 3.754 1.5h19.353a2.256 2.256 0 0 1 2.254 2.254v8.445h1.5V3.754A3.758 3.758 0 0 0 23.107 0H3.754A3.758 3.758 0 0 0 0 3.754v27.992A3.758 3.758 0 0 0 3.754 35.5h21.285V34H3.754A2.256 2.256 0 0 1 1.5 31.746",
  fill: "#000",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement(Path, {
  d: "M20.933 10.513h-9.408a.75.75 0 0 0 0 1.5h9.408a.75.75 0 0 0 0-1.5M21.683 19.756a.75.75 0 0 0-.75-.75H6.588a.75.75 0 0 0 0 1.5h14.345a.75.75 0 0 0 .75-.75M33.59 12.689l-8.78 12.786-1.32 1.94-1.891 1.431.627-2.214 9.698-14.126a.718.718 0 0 0 .109-.241.762.762 0 0 0 .182-.185l.154-.224a.42.42 0 0 1 .268-.173.409.409 0 0 1 .305.064l.544.373a.4.4 0 0 1 .168.263.401.401 0 0 1-.064.306m1.539-.58a1.89 1.89 0 0 0-.796-1.227l-.545-.373a1.889 1.889 0 0 0-1.43-.3 1.907 1.907 0 0 0-1.026.555 2.71 2.71 0 0 0-2.85 1.1l-2.288 3.334a.749.749 0 0 0 .192 1.042l.423.291a.776.776 0 0 0 .442.133l-6.26 9.116a1.24 1.24 0 0 0-.176.373l-.84 2.922a1.258 1.258 0 0 0 .504 1.405c.22.152.472.228.722.228.27 0 .538-.088.769-.263l2.42-1.83c.114-.085.212-.187.287-.299l10.15-14.778v-.003c.288-.42.395-.928.302-1.426M18.066 28.92l-3.58 1.69a1.576 1.576 0 0 1-1.155-.223l-1.82-1.176a2.238 2.238 0 0 0-2.379-.043l-2.928 1.746a.749.749 0 1 0 .767 1.288l2.93-1.746a.754.754 0 0 1 .795.014l1.82 1.177a3.091 3.091 0 0 0 2.39.407.725.725 0 0 0 .143-.051l3.658-1.726a.75.75 0 1 0-.64-1.356",
  fill: "#000"
})));

// #D63D34
const Info = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none"
  //@ts-ignore
  ,
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement(Circle, {
  cx: 10,
  cy: 10,
  r: 10,
  fill: props.color
}), /*#__PURE__*/React.createElement(Path, {
  d: "M12 4H8v7.944h4V4zm0 13v-2.889H8V17h4z",
  fill: "#fff"
}));
const UploadCloud = _ref => {
  let {
    width = 42,
    height = 36,
    color = '#FFFFFF'
  } = _ref;
  return /*#__PURE__*/React.createElement(Svg, {
    width,
    height
  }, /*#__PURE__*/React.createElement(G, {
    fill: color,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M37.627 12.81a10.42 10.42 0 0 0-1.24-.588c.029-.24.088-.792.088-1.28C36.475 4.908 31.391 0 25.143 0c-3.594 0-7.011 1.675-9.141 4.478a11.41 11.41 0 0 0-.616.923 7.705 7.705 0 0 0-1.066-.51 7.332 7.332 0 0 0-2.528-.445c-3.963 0-7.188 3.114-7.188 6.94 0 .493.09 1.018.13 1.236a9.963 9.963 0 0 0-1.088.66C1.363 14.92 0 17.536 0 20.28 0 25.088 4.051 29 9.03 29h3.35a.73.73 0 0 0 .743-.717.73.73 0 0 0-.744-.718H9.03c-4.16 0-7.544-3.268-7.544-7.285 0-2.326 1.11-4.458 3.046-5.848.408-.292.984-.587.988-.59.51-.256.807-.862.69-1.408-.001-.006-.12-.57-.12-1.047 0-3.036 2.558-5.506 5.702-5.506.69 0 1.363.118 2 .352.493.18 1.073.54 1.078.543a1.2 1.2 0 0 0 .914.15c.311-.076.579-.276.736-.55.003-.006.353-.619.68-1.05 1.851-2.436 4.82-3.892 7.943-3.892 5.43 0 9.846 4.265 9.846 9.508 0 .538-.089 1.21-.09 1.216-.077.564.277 1.144.822 1.35.007.003.68.263 1.14.53 2.287 1.332 3.653 3.665 3.653 6.241 0 4.018-3.384 7.285-7.544 7.285h-3.35a.73.73 0 0 0-.743.718.73.73 0 0 0 .744.718h3.349c4.979 0 9.03-3.912 9.03-8.72 0-3.083-1.635-5.876-4.373-7.47Z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M21 36c.431 0 .782-.31.782-.69V17.084l6.186 5.47a.836.836 0 0 0 .553.203c.2 0 .4-.068.552-.203a.635.635 0 0 0 0-.977l-7.018-6.204c-.562-.498-1.548-.498-2.11-.001l-7.018 6.205a.635.635 0 0 0 0 .977c.305.27.8.27 1.105 0l6.187-5.47V35.31c0 .38.35.69.781.69Z"
  })));
};
const Search = props => /*#__PURE__*/React.createElement(Svg, props, /*#__PURE__*/React.createElement(G, null, /*#__PURE__*/React.createElement(G, null, /*#__PURE__*/React.createElement(Ellipse, {
  cx: "14.79",
  cy: "15.06",
  rx: "14.04",
  ry: "14.31",
  fill: "none",
  stroke: props.color || '#fff',
  strokeMiterlimit: "10",
  strokeWidth: "1.5px"
}), /*#__PURE__*/React.createElement(Line, {
  x1: "23.31",
  y1: "26.58",
  x2: "33.47",
  y2: "37.88",
  fill: "none",
  stroke: props.color || '#fff',
  strokeMiterlimit: "10",
  strokeWidth: "1.5px"
}))));
const CircleCross = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 256 256"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: "#d63d34",
    d: "M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24Zm37.66 130.34a8 8 0 0 1-11.32 11.32L128 139.31l-26.34 26.35a8 8 0 0 1-11.32-11.32L116.69 128l-26.35-26.34a8 8 0 0 1 11.32-11.32L128 116.69l26.34-26.35a8 8 0 0 1 11.32 11.32L139.31 128Z"
  }));
};
const CameraOutline = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "m350.54 148.68-26.62-42.06C318.31 100.08 310.62 96 302 96h-92c-8.62 0-16.31 4.08-21.92 10.62l-26.62 42.06C155.85 155.23 148.62 160 140 160H80a32 32 0 0 0-32 32v192a32 32 0 0 0 32 32h352a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32h-59c-8.65 0-16.85-4.77-22.46-11.32z",
    fill: "none",
    stroke: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 256,
    cy: 272,
    r: 80,
    fill: "none",
    stroke: props.color,
    strokeMiterlimit: 10,
    strokeWidth: 32
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "none",
    stroke: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    d: "M124 158v-22h-24v22"
  }));
};
const PayStubIcon = /*#__PURE__*/memo(PayStub);
const OtherDocumentsIcon = /*#__PURE__*/memo(OtherDocuments);
const UploadHistoryIcon = /*#__PURE__*/memo(UploadHistory);
const PendingReviewIcon = /*#__PURE__*/memo(PendingReview);
const ApprovedIcon = /*#__PURE__*/memo(Approved);
const HomeOwnersInsuranceIcon = /*#__PURE__*/memo(HomeOwnersInsurance);
const W2Icon = /*#__PURE__*/memo(W2);
const TaxReturnsIcon = /*#__PURE__*/memo(TaxReturns);
const DisclosuresIcon = /*#__PURE__*/memo(Disclosures);
const InfoIcon = /*#__PURE__*/memo(Info);
const UploadCloudIcon = /*#__PURE__*/memo(UploadCloud);
const SearchIcon = /*#__PURE__*/memo(Search);
const CircleCrossIcon = /*#__PURE__*/memo(CircleCross);
const CameraOutlineIcon = /*#__PURE__*/memo(CameraOutline);
export { PayStubIcon, OtherDocumentsIcon, UploadHistoryIcon, PendingReviewIcon, ApprovedIcon, W2Icon, HomeOwnersInsuranceIcon, TaxReturnsIcon, DisclosuresIcon, InfoIcon, UploadCloudIcon, SearchIcon, CircleCrossIcon, CameraOutlineIcon };
//# sourceMappingURL=index.js.map